import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { DescriptorApp } from 'DescriptorApp';
import { GlobalErrorBoundary } from 'GlobalErrorBoundary';
import { store } from 'store';

import { PopupProvider } from 'contexts/PopupContext';
import { PWAContextProvider } from 'contexts/PWAContext';
import { ToastsProvider } from 'contexts/ToastsContext';

import { WebSocketProvider } from 'components/shared/WebSocketProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const DescriptorAppContainer = () => (
  <Provider store={store}>
    <GlobalErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastsProvider>
          <WebSocketProvider>
            <PopupProvider>
              <PWAContextProvider>
                <DescriptorApp />
              </PWAContextProvider>
            </PopupProvider>
          </WebSocketProvider>
        </ToastsProvider>
      </QueryClientProvider>
    </GlobalErrorBoundary>
  </Provider>
);
